import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter5Adapter } from 'use-query-params/adapters/react-router-5';

import * as GoogleTagManager from 'containers/GoogleTagManager';
import RouteTracker from 'containers/RouteTracker';
import Loading from 'components/Loading';
import { isNotFoundLocation } from 'components/RedirectAs404/isNotFoundLocation';
import lazyWithRetry from 'utils/lazyWithRetry';
import { useIdleTimeout } from 'utils/hooks';

import { Page } from './routes';
import { ValidRoutes } from './ValidRoutes';
import * as S from './styles';

const NotFoundPage = lazyWithRetry(Page.NotFound);

export function Router() {
  GoogleTagManager.init();
  useIdleTimeout();

  return (
    <S.Wrap>
      <RouteTracker />
      <QueryParamProvider adapter={ReactRouter5Adapter}>
        <Switch>
          <Route
            render={(props) =>
              isNotFoundLocation(props.location) ? (
                <React.Suspense fallback={<Loading />}>
                  <NotFoundPage />
                </React.Suspense>
              ) : (
                <ValidRoutes />
              )
            }
          />
        </Switch>
      </QueryParamProvider>
    </S.Wrap>
  );
}
